﻿<script setup>
    import { useDialogPluginComponent } from 'quasar'
    const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()
    defineEmits([...useDialogPluginComponent.emits])

    const props = defineProps({
        data: Object
    });
</script>

<template>
    <q-dialog ref="dialogRef" @hide="onDialogHide" :persistent="true">
        <window title="Validation Error" icon="error" size="sm">
            <template #actions>
                <btnOk flat @click="onDialogOK" v-if="data.IsValid" />
                <btnCancel flat @click="onDialogCancel" />
            </template>

            <div v-if="data.Errors?.length">
                <h4>Errors</h4>
                <div v-for="e in data.Errors">- {{e.Message}}</div>
            </div>

            <div v-if="data.Warnings?.length">
                <h4>Warnings</h4>
                <div v-for="e in data.Warnings">- {{e.Message}}</div>
            </div>

            <div v-if="data.Alerts?.length">
                <h4>Alerts</h4>
                <div v-for="e in data.Alerts">- {{e.Message}}</div>
            </div>
        </window>
    </q-dialog>
</template>